export default __webpack_public_path__ + "static/media/Biwo_bienvenida.0cccf690.png";